import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reload-confirmer"
export default class extends Controller {
  checkBeforeLeave(event) {
    event.preventDefault()
    return event.returnValue = "Are you sure you want to leave? the changes that you have not save will not be published"
  }
}
